<template>
  <div class="flex flex-col gap-1.5">
    <div class="text-secondary text-sm font-medium">
      {{ label }}
    </div>
    <div class="relative">
      <div
        ref="input"
        :key="key"
        :class="{
          'h-[128px] min-h-[44px] py-3 overflow-y-auto resize-y':
            type === 'textarea',
          'h-[44px] py-2.5 overflow-y-hidden whitespace-nowrap':
            type === 'input',
        }"
        class="font-medium text-primary w-full px-3.5 border border-primary rounded overflow-x-auto"
        contenteditable="true"
        @input="handleInput"
        @keydown="handleKeydown"
        @click="handleClickOnTag"
        v-html="fieldValue"
      />
      <Dropdown
        :showDropdown="showDropdown"
        :filteredTags="filteredTags"
        :selectedDropdownIndex="selectedDropdownIndex"
        @selectTag="insertTagFromDropdown"
      />
    </div>
    <CharacterCount
      v-if="maxChars"
      :maxChars="maxChars"
      :charCount="charCount"
    />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useSmartTagInput } from "@/Composables/useSmartTagInput";
import Dropdown from "./Dropdown.vue";
import CharacterCount from "./CharacterCount.vue";
import { clone } from "lodash";

const emit = defineEmits(["onInput"]);

const props = defineProps({
  label: { type: String, required: true },
  type: { type: String, required: true },
  tags: { type: Array, required: true },
  maxChars: { type: Number, required: false },
  value: { type: String, required: true },
  default: { type: String, default: "" },
});

const {
  input,
  text,
  charCount,
  showDropdown,
  selectedDropdownIndex,
  filteredTags,
  handleInput,
  handleKeydown,
  insertTagFromDropdown,
  handleClickOnTag,
  createSmartTagsFromString,
} = useSmartTagInput(props);

const key = ref(0);
const fieldValue = ref(createSmartTagsFromString(text.value));
const originalValue = clone(props.value);

watch(
  text,
  () => {
    emit("onInput", text.value);
  },
  {
    immediate: true,
  }
);

const cancel = () => {
  key.value++;
  emit("onInput", originalValue);
};

defineExpose({ cancel });
</script>
